import { QuestionType, SectionType } from 'modules/forms/components/newFormEditor/types'

function returnOrGenerateId(id?: string): string {
  return id || Math.random().toString()
}

type ElementType = QuestionType | SectionType

function isSection(element: ElementType): element is SectionType {
  return element.type === 'section'
}

function elementToFragment(element: ElementType, formId: string, sectionId?: string) {
  return {
    id: returnOrGenerateId(element.id),
    invariantId:
      ('invariantId' in element ? element.invariantId : undefined) ?? crypto.randomUUID(),
    label: element.label,
    description: element.description || '',
    formId,
    sectionId: sectionId || ('sectionId' in element ? element.sectionId : '') || '',
    type: element.type,
    position: element.position,
    mandatory: element.mandatory,
    locked: element.locked,
    createdAt: new Date().toISOString(),
    updatedAt: new Date().toISOString(),
    options: (element.options || []).map((option) => ({
      ...option,
      id: returnOrGenerateId(option.id),
    })),
    params: { ...element.params, locked: element.locked ?? null },
  }
}

export function flattenElements(elements: ElementType[], formId: string) {
  return elements.flatMap((element) => {
    const fragment = elementToFragment(element, formId)
    const flattenedElements = [fragment]

    if (isSection(element)) {
      const children = element.elements.map((child) =>
        elementToFragment(child, formId, fragment.id)
      )
      flattenedElements.push(...children)
    }

    return flattenedElements
  })
}
